import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "views/public/Home";
import CookieConsent from "components/CookieConsent";

// Lazy: ayrı chunk'lara çıkar — anasayfa ziyaretçisi yüklemesin
const AdminLayout = lazy(() => import("layouts/admin"));
const AuthLayout = lazy(() => import("layouts/auth"));
const Features = lazy(() => import("views/public/Features"));
const Contact = lazy(() => import("views/public/Contact"));
const BlogList = lazy(() => import("views/public/BlogList"));
const BlogPost = lazy(() => import("views/public/blog/BlogPost"));
const SSSList = lazy(() => import("views/public/sss/SSSList"));
const VergiTakvimi = lazy(() => import("views/public/VergiTakvimi").then(m => ({ default: m.VergiTakvimi })));
const AyVergiTarihleri = lazy(() => import("views/public/VergiTakvimi").then(m => ({ default: m.AyVergiTarihleri })));
const HaberDetay = lazy(() => import("views/public/HaberDetay"));
const MevzuatHaberleri = lazy(() => import("views/public/MevzuatHaberleri"));
const Gizlilik = lazy(() => import("views/public/Gizlilik"));
const KullanimSartlari = lazy(() => import("views/public/KullanimSartlari"));
const MobilUygulama = lazy(() => import("views/public/MobilUygulama"));
const NotFound = lazy(() => import("views/public/NotFound"));

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem("mt_token");
  if (!token) return <Navigate to="/auth/sign-in" replace />;
  return children;
}

const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-white">
    <div className="h-12 w-12 animate-spin rounded-full border-4 border-brand-100 border-t-brand-500" />
  </div>
);

const App = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public marketing pages */}
        <Route path="/" element={<Home />} />
        <Route path="/ozellikler" element={<Features />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/sss" element={<SSSList />} />

        {/* Vergi takvimi (public) */}
        <Route path="/vergi-takvimi" element={<VergiTakvimi />} />
        <Route path="/vergi-tarihleri/:ayslug" element={<AyVergiTarihleri />} />

        {/* Mevzuat haberleri — public liste sayfası */}
        <Route path="/mevzuat-haberleri" element={<MevzuatHaberleri />} />
        {/* Detay sayfaları kaldırıldı; rotalar listeye yönlendiriyor ki eski
            bağlantılar 404 vermesin. Bkz. views/public/HaberDetay.tsx */}
        <Route path="/mevzuat-haberleri/:source/:slug" element={<HaberDetay />} />
        <Route path="/haber/:slug" element={<HaberDetay />} />

        {/* Gizlilik / KVKK (zorunlu yasal sayfa) */}
        <Route path="/gizlilik" element={<Gizlilik />} />
        <Route path="/privacy" element={<Gizlilik />} />
        <Route path="/kvkk" element={<Gizlilik />} />

        {/* Kullanım Şartları (zorunlu yasal sayfa) */}
        <Route path="/kullanim-sartlari" element={<KullanimSartlari />} />

        {/* Mobil uygulama landing — App Store / Play Store tanıtım */}
        <Route path="/mobil-uygulama" element={<MobilUygulama />} />
        <Route path="/uygulama" element={<MobilUygulama />} />
        <Route path="/indir" element={<MobilUygulama />} />
        <Route path="/ios" element={<MobilUygulama />} />

        {/* Auth pages */}
        <Route path="auth/*" element={<AuthLayout />} />

        {/* Admin (protected) */}
        <Route path="admin/*" element={<RequireAuth><AdminLayout /></RequireAuth>} />

        {/* 404 — public dışı tüm bilinmeyen yollar */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Çerez onayı — tüm sayfalarda, ilk ziyarette bir kez */}
      <CookieConsent />
    </Suspense>
  );
};

export default App;
